import { render } from "./IconMenu.vue?vue&type=template&id=a3d14e86"
const script = {}

import exportComponent from "/Users/thuanluu/code/owlx/more9_venues/package/private/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconMenu.vue"]])

export default __exports__